import React, { Component } from "react";
import { is } from "immutable";
import Request from "superagent";

import { API_BASE } from "./api";
import appHistory from "./appHistory";
import Player from "./Player";
import { MAX_NAME_LEN } from "./PlayerList";
import { Grid } from "./GridGameLayout";
import MSquaresHeader from "./MSquaresHeader";
import withLivePicks from "./withLivePicks";

const STYLE_WRAPPER = {
  fontFamily: '"acumin-pro-extra-condensed",sans-serif',
  fontWeight: 300,
  margin: "20px auto 40px",
  maxWidth: 600,
  padding: "0px 20px",
  fontSize: 24,
  // fontSize: 32,
  // textTransform: "capitalize",
};

class MPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { mode: "INIT", initials: "", name: "" };
  }

  componentDidMount() {
    const { lobbyCode } = this.props;

    if (
      sessionStorage["mpicker-lobbyCode"] === lobbyCode &&
      sessionStorage["mpicker-shortName"] &&
      sessionStorage["mpicker-longName"]
    ) {
      this.setState({
        mode: "OK",
        player: new Player({
          longName: sessionStorage["mpicker-longName"],
          shortName: sessionStorage["mpicker-shortName"],
        }),
      });
    } else {
      this.refreshLobby();
    }
  }

  refreshLobby() {
    const { lobbyCode } = this.props;
    this.clearSessionStorage();

    Request.get(`${API_BASE}/lobby/${lobbyCode}`).end((err, res) => {
      if (err) {
        this.setState({ mode: "ERROR" });
        return;
      }
      const data = res.body.data;
      if (data.state > 0) {
        appHistory.push(`/gm/${lobbyCode}`);
        return;
      }
      this.setState({ mode: "OK" });
    });
  }

  clearSessionStorage() {
    delete sessionStorage["mpicker-lobbyCode"];
    delete sessionStorage["mpicker-shortName"];
    delete sessionStorage["mpicker-longName"];
  }

  componentWillReceiveProps(nextProps) {
    const nextPicks = nextProps.picks;
    console.log("nextPicks", nextPicks.toJS());
    if (nextPicks && nextPicks.state > 0) {
      // Game has already begun!
      appHistory.push(`/gm/${nextProps.lobbyCode}`);
    } else if (nextPicks && this.state.player && !nextPicks.players.includes(this.state.player)) {
      alert("The game was restarted by the admin.");
      this.clearSessionStorage();
      this.setState({ mode: "INIT" });
      this.refreshLobby();
    }
  }

  onChangeName = (e) => {
    this.setState({ name: e.target.value.substr(0, MAX_NAME_LEN) });
  };

  onChangeInitials = (e) => {
    this.setState({ initials: e.target.value.substr(0, 3).toUpperCase() });
  };

  onSubmit = (e) => {
    if (this.nameInFlight) {
      return;
    }
    if (this.state.initials.length < 2) {
      alert("Initials must be 2 or 3 characters");
      return;
    }
    if (this.state.name.length < 2) {
      alert("Name must be at least 2 characters");
      return;
    }
    const { lobbyCode } = this.props;
    this.nameInFlight = true;
    Request.post(`${API_BASE}/lobby/${lobbyCode}/players`)
      .send({ shortName: this.state.initials, longName: this.state.name })
      .end((err, res) => {
        this.nameInFlight = false;

        if (err) {
          this.setState({ mode: "ERROR" });
          return;
        }

        const body = res.body;
        if (body.success) {
          sessionStorage["mpicker-shortName"] = body.shortName;
          sessionStorage["mpicker-longName"] = body.longName;
          sessionStorage["mpicker-lobbyCode"] = lobbyCode;
          this.setState({
            mode: "OK",
            player: new Player({ shortName: body.shortName, longName: body.longName }),
          });
          return;
        } else {
          if (body.errName === "DUP_PLAYER") {
            alert(`Initials ${this.state.initials} already in use. Pick something else`);
            this.setState({ initials: "" }, () => {
              this.initialsEl.focus();
            });
            return;
          }
          this.setState({ mode: "ERROR" });
          return;
        }
      });
  };

  onClickCell = (row, col) => {
    const { lobbyCode, picks } = this.props;
    const { player } = this.state;

    const playerAtCell = picks.getPlayer(row, col);
    const data = { row, col, shortName: player.shortName, longName: player.longName };

    if (!playerAtCell) {
      Request.post(`${API_BASE}/lobby/${lobbyCode}/picks`)
        .send(data)
        .end(this.handlePickRes);
    } else if (is(playerAtCell, player)) {
      Request.delete(`${API_BASE}/lobby/${lobbyCode}/picks`)
        .send(data)
        .end(this.handlePickRes);
    }
  };

  handlePickRes = (err, res) => {
    if (err || !res.body.success) {
      console.log("add pick error", err, res.body);
    }
  };

  // TODO design
  render() {
    if (this.state.mode === "INIT") {
      return <div>loading</div>;
    } else if (this.state.mode === "ERROR") {
      return <div>something went wrong</div>;
    }

    const { player } = this.state;
    if (player) {
      return (
        <div style={STYLE_WRAPPER}>
          <MSquaresHeader />
          <div>
            <h1>Join a game</h1>
          </div>
          <div>
            <h4>Step 2: Select your squares, {player.longName}:</h4>
          </div>
          <div style={{ paddingBottom: 10 }}>
            Hang on once you've selected all the squares you want. The original creator of the game
            will start it.
          </div>
          <Grid picks={this.props.picks} onClickCell={this.onClickCell} selectedPlayer={player} />
        </div>
      );
    } else {
      const { name, initials } = this.state;
      const enabled = name.length > 1 && initials.length > 1;

      return (
        <div style={STYLE_WRAPPER}>
          <MSquaresHeader />
          <div>
            <h1>Join a game</h1>
          </div>
          <div>
            <h4>Step 1: What's your name?</h4>
          </div>
          <label htmlFor="name" style={{ display: "block" }}>
            Name:
          </label>
          <input
            id="name"
            type="text"
            value={name}
            style={{ display: "block" }}
            onChange={this.onChangeName}
          />
          <br />
          <label htmlFor="initials" style={{ display: "block" }}>
            Initials:
          </label>
          <input
            type="text"
            id="initials"
            value={initials}
            style={{ display: "block" }}
            onChange={this.onChangeInitials}
            ref={(el) => {
              this.initialsEl = el;
            }}
          />
          <br />
          <button onClick={this.onSubmit} disabled={!enabled}>
            Join
          </button>
        </div>
      );
    }
  }
}
export default withLivePicks(MPicker);



// WEBPACK FOOTER //
// ./src/MPicker.js